import { render, staticRenderFns } from "./CompanyNotFound.vue?vue&type=template&id=2f117fc2&scoped=true&functional=true&"
import script from "./CompanyNotFound.vue?vue&type=script&lang=js&"
export * from "./CompanyNotFound.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotFound.vue?vue&type=style&index=0&id=2f117fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2f117fc2",
  null
  
)

export default component.exports